import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

export interface CaseActionStatusChipProps {
  actionStatusName: string;
}

export const CaseActionStatusChip = ({
  actionStatusName
}: CaseActionStatusChipProps): JSX.Element => {
  return <StatusChip>{actionStatusName}</StatusChip>;
};

export interface ExternalStatusChipProps {
  statusName: string | null;
}

export const ExternalStatusChip = ({
  statusName
}: ExternalStatusChipProps): JSX.Element => {
  return (
    <Tooltip title="External status">
      <InfoChip>{statusName ?? "Awaiting Sync"}</InfoChip>
    </Tooltip>
  );
};

const StatusChip = styled("span")`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 8px;
  font-size: 11px;
  border-radius: 3px;
  background-color: #d9d9d9;
  white-space: nowrap;
  flex-shrink: 0;
`;

const InfoChip = styled(StatusChip)`
  background-color: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.info.contrastText};
`;
